module.exports = __webpack_public_path__ + "media/bootstrap-icons/dot-f764be06.svg";